import { render, staticRenderFns } from "./QuestionChoices.vue?vue&type=template&id=2e295e55&scoped=true&"
import script from "./QuestionChoices.vue?vue&type=script&lang=js&"
export * from "./QuestionChoices.vue?vue&type=script&lang=js&"
import style0 from "./QuestionChoices.vue?vue&type=style&index=0&id=2e295e55&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e295e55",
  null
  
)

export default component.exports